import { useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from "../../../Root";
import { LeadService, OnboardingSectionLead } from "../../../../services/LeadService";
import { ItemBlackList } from "../ItemBlackList";
import { RiskLevelSection } from "../RiskLevelSection";
import { ItemCompanyRecord } from "../ItemCompanyRecord";
import moment from "moment";
moment.locale('es');


export const useLeadSection = (changeAlert: ChangeAlertCallbackType, changeLoader: ChangeLoaderCallbackType, config, lead) => {
    const CreateModalBlackList = (name, blacklistValidations, key) => {
        return <ItemBlackList blacklistValidations={blacklistValidations} name={name} key={key} />
    }
    
    const GetRiskLevel = (data) => {
        return <RiskLevelSection data={data} lead={lead} changeAlert={changeAlert} handleSectionChange={handleSectionChange} />
    }

    const GetCompanyRecord = (name, data, key) => {
        return <ItemCompanyRecord data={lead.uuid} name={name} key={key} changeAlert={changeAlert} changeLoader={changeLoader}/>
    }
    
    let sections = {
        COMPANY_INFO: [
            { type: "subtitle", name: "Datos generales", subSection: "COMPANY_INFO_GENERAL_INFO" },
            { key: ["geolocation", "latitude", "longitude"], name: "Geolocalización" },
            { key: "social_reason", name: "Denominación o Rozón Social" },
            { key: "comercial_name", name: "Nombre comercial" },
            { key: "account_number", name: "Número de cuenta" },
            { key: "website", type: "link", name: "Sitio web o red social" },
            { key: "taxid", name: "RFC" },
            { key: "email", name: "Correo electrónico" },
            { key: ["phone", "phone"], name: "Número telefónico" },
            { key: "constitution_date", type: "date", name: "Fecha de constitución" },
            { key: "constitution_country_desc", name: "Nacionalidad" },
            { key: "gender", name: "Género" },
            { key: "company_activities", name: "Servicios que ofrece" },
            { key: "economic_activity_desc", name: "Giro mercantil, actividad" },
            { key: "is_pep_related", type: "pep", name: "En los últimos 12 meses, ¿algún representante legal o accionista tiene o ha tenido un puesto político, gubernamental, judicial o militar alto?" },
            { key: "reason_account", name: "En caso de residentes en el extranjero, el motivo por el cual quiere una cuenta de albo en México" },
            { key: "cer_file", type: "link", name: "No. serie de Firma electrónica" },
            { action: 1, key: "constitutive_act_file", name: "Acta constitutiva", type: "element", element: GetCompanyRecord, getData: true },
            { action: 2, key: "constitutive_act_file", type: "detail", name: "Ver detalle de Acta constitutiva" },
            { action: 3, key: "constitutive_act_file", type: "link", name: "Acta constitutiva" },
            { key: "taxid_file", type: "link", name: "Cédula RFC o CIF" },
            { key: "proof_of_address", type: "link", name: "Comprobante de domicilio" },
            { type: "subtitle", name: "Domicilio de la empresa", subSection: "COMPANY_INFO_ADDRESS" },
            { key: ["address", "street"], name: "Calle" },
            { key: ["address", "extnum"], name: "No. exterior e interior" },
            { key: ["address", "locality_desc"], name: "Colonia" },
            { key: ["address", "town"], name: "Alcaldía" },
            { key: ["address", "state_desc"], name: "Ciudad" },
            { key: ["address", "zip"], name: "Código Postal" },
            { key: ["address", "country_desc"], name: "País" },
            { type: "subtitle", name: "Domicilio fiscal" },
            { key: ["notification_address", "street"], name: "Calle" },
            { key: ["notification_address", "extnum"], name: "No. exterior e interior" },
            { key: ["notification_address", "locality_desc"], name: "Colonia" },
            { key: ["notification_address", "town"], name: "Alcaldía" },
            { key: ["notification_address", "state_desc"], name: "Ciudad" },
            { key: ["notification_address", "zip"], name: "Código Postal" },
            { key: ["notification_address", "country_desc"], name: "País" },
        ],
        LEGAL_REPRESENTATIVES: [
            { type: "subtitle", name: "Representante legal", count: 1, subSection: "LEGAL_REPRESENTATIVES" },
            { type: "subtitle", name: "Datos generales" },
            { key: "name", name: "Nombre completo" },
            { key: "taxid", name: "RFC" },
            { key: "phone", name: "Teléfono" },
            { key: "email", name: "Correo electrónico" },
            { type: "subtitle", name: "Documentación" },
            { key: ["phone", "phone"], name: "Poderes de representante legal" },
            { key: "identification_type", type: "catalogs", name: "Tipo de identificación" },
            { key: "identification_front", type: "link", name: "Identificación frontal" },
            { key: "identification_back", type: "link", name: "Identificación reversa" },
            { key: "selfie", type: "link", name: "Prueba de vida" },
            { key: "all_images", type: "image", name: "Ver todas las imágenes" }
        ],
        REAL_OWNERS: [
            { key: "name", name: "Tipo de propietario real" },
            { type: "subtitle", name: "Propietario", count: 1, subSection: "REAL_OWNERS" },
            { type: "subtitle", name: "Datos bolsa de valores" },
            { key: "Cotiza", name: "Cotiza en bolsa de valores" },
            { key: "bolsa", name: "Nombre de la bolsa de valores" },
            { key: "Clave", name: "Clave de pizarra" },
            { type: "subtitle", name: "Declaratoria" },
            { type: "paragraph", key: "statement" },
    
            { type: "subtitle", name: "Datos generales" },
            { key: "name", name: "Nombre completo" },
            { key: "gender", name: "Género" },
            { key: "bdate", type: "date", name: "Fecha de nacimiento" },
            { key: "bstate", name: "Estado de nacimiento" },
            { key: "bcountry", name: "País de nacimiento" },
            { key: "occupation_desc", name: "Ocupación, profesión, actividad" },
            { key: "populationid", name: "CURP" },
            { key: "phone", name: "Teléfono" },
            { key: "email", name: "Correo electrónico" },
    
            { key: "identification_type", type: "catalogs", name: "Tipo de identificación" },
            { key: "identification_front", type: "link", name: "Identificación frontal" },
            { key: "identification_back", type: "link", name: "Identificación reversa" },
            { key: "all_images", type: "image", name: "Ver todas las imágenes" },
    
            { type: "subtitle", name: "Domicilio" },
            { key: ["address", "street"], name: "Calle" },
            { key: ["address", "extnum"], name: "No. exterior e interior" },
            { key: ["address", "locality_desc"], name: "Colonia" },
            { key: ["address", "town"], name: "Alcaldía" },
            { key: ["address", "state_desc"], name: "Ciudad" },
            { key: ["address", "zip"], name: "Código Postal" },
            { key: ["address", "country_desc"], name: "País" },
        ],
        ACCOUNT_ADMIN: [
            { type: "subtitle", name: "Datos generales", subSection: "ACCOUNT_ADMIN_GENERAL_INFO" },
            { key: "name", name: "Nombre completo" },
            { key: "email", name: "Correo electrónico" },
            { key: "phone", name: "Teléfono" },
            { type: "subtitle", name: "Documentación" },
            { key: ["identification", "type"], type: "catalogs", name: "Tipo de identificación" },
            { key: ["identification", "front"], type: "link", name: "Documento de identificación" },
            { key: ["identification", "back"], type: "link", name: "Identificación reversa" }
        ],
        SHAREHOLDERS: [
            { key: "1", type: "subtitle", name: "Accionista", count: 1, subSection: "SHAREHOLDERS" },
            { key: "2", type: "subtitle", name: "Datos generales" },
            { key: "gname", name: "Nombre o denominación" },
            { key: "bdate", type: "date", name: "Fecha de nacimiento o constitución" },
            { key: "country_desc", name: "Nacionalidad" },
            { key: "percentage_shares", name: "Porcentaje de participación" },
            { key: "tax_id", name: "RFC" },
        ],
        RISK_LEVEL: [
            { key: "risk_level", name: "Riesgo", type: "element", element: GetRiskLevel, subSection: "RISK_LEVEL" }
        ],
        LEAD_DETAILS: [
            { type: "subtitle", name: "Datos generales", subSection: "LEAD_DETAILS_GENERAL_INFO"  },
            { key: "type", name: "Tipo de persona" },
            { key: "main_use", name: "Uso principal de la cuenta" },
            { key: "account_name", name: "Nombre de la Cuenta" },
            { key: "1", type: "subtitle", name: "Perfil transaccional declarado" },
            { key: "2", type: "subtitle", name: "Recepción de transferencias" },
            { key: ["money_in", "frecuency_monthly"], name: "Frecuencia mensual" },
            { key: ["money_in", "amount_monthly"], name: "Monto mensual" },
            { key: ["money_in", "counterparty_number"], name: "Numero de contrapartes" },
            { type: "subtitle", name: "Envío de trasnferencias" },
            { key: ["money_out", "frecuency_monthly"], name: "Frecuencia mensual" },
            { key: ["money_out", "amount_monthly"], name: "Monto mensual" },
            { key: ["money_out", "counterparty_number"], name: "Numero de contrapartes" },
        ],
        ADDITIONAL_INFORMATION: [
            { type: "subtitle", name: "Organigrama empresarial", section: "COMPANY_ORGANIZATION", subSection: "COMPANY_ORGANIZATION" },
            { key: "ceo_name", name: "Director general", section: "COMPANY_ORGANIZATION" },
            { key: "ceo_bdate", type: "date", name: "Fecha de nacimiento", section: "COMPANY_ORGANIZATION" },
    
            { type: "subtitle", name: "Empleados", section: "COMPANY_ORGANIZATION" },
            { key: "employees", type: "array2", section: "COMPANY_ORGANIZATION", obj: { name: "Nombre", bdate: "Fecha de nacimiento", position: "Cargo" } },
    
            { type: "subtitle", name: "Persona Expuesta Politicamente", section: "PEP_RELATION", subSection: "PEP_RELATION" },
            { key: "who_has_relation", name: "Relación con PEP", section: "PEP_RELATION" },
            { key: "country", name: "Lugar de residencia", section: "PEP_RELATION" },
            { key: "dependence", name: "Nombre de la dependencia a Cargo", section: "PEP_RELATION" },
            { key: "job_position", name: "Nombre del Cargo", section: "PEP_RELATION" },
            { key: "estimated_salary", name: "Sueldo estimado", section: "PEP_RELATION" },
            { key: "date_admission", name: "Fecha admisión", type: "date", section: "PEP_RELATION" },
    
            { type: "subtitle", name: "Dependientes", section: "PEP_RELATION" },
            { key: "dependents", type: "array2", section: "PEP_RELATION", obj: { gname: "Nombre", bdate: "Fecha de nacimiento", relation_desc: "Tipo de relación con PEP" } },
    
            { type: "subtitle", name: "Datos adicionales de la empresa", section: "ECONOMIC_ACTIVITY", subSection: "ECONOMIC_ACTIVITY" },
            { key: "activity_years", name: "Años desempeñando la actividad", section: "ECONOMIC_ACTIVITY" },
            { key: "monthly_income", name: "Ingresos mensuales aproximados", section: "ECONOMIC_ACTIVITY" },
            { key: "have_additional_income", type: "boolean", name: "¿Tienes ingresos adicionales?", section: "ECONOMIC_ACTIVITY" },
            { key: "additional_income", name: "Fuente de ingresos adicionales", section: "ECONOMIC_ACTIVITY" },
    
            { type: "subtitle", name: "Información complementaria", section: "COMPLEMENTARY_INFORMATION", subSection: "COMPLEMENTARY_INFORMATION"  },
            { key: "has_foreign_client", type: "boolean", name: "¿Tienes clientes y/o proveedores en el extranjero?", section: "COMPLEMENTARY_INFORMATION" },
            // { key: "has_foreign_client", type: "boolean", name: "Si / No ¿Que país?", section: "COMPLEMENTARY_INFORMATION" },
            { key: "products_or_services", name: "¿Qué productos o servicios comercializas?", section: "COMPLEMENTARY_INFORMATION" },
            { key: "quantity_employees", name: "Número de empleados", section: "COMPLEMENTARY_INFORMATION" },
            { key: "has_point_of_sale", type: "boolean", name: "¿Tiene sucursales o puntos de venta?", section: "COMPLEMENTARY_INFORMATION" },
            { key: "quantity_point_of_sale", type: "boolean", name: "Número de sucursales o puntos de venta", section: "COMPLEMENTARY_INFORMATION" },
            { key: "location_state", name: "Ciudades en donde se ubican", section: "COMPLEMENTARY_INFORMATION" },
            { key: "moneyin_monthly", name: "Ingresos mensuales aproximados", section: "COMPLEMENTARY_INFORMATION" },
            { key: "annual_statement", type: 'link', name: "Declaración anual de impuestos reciente", section: "COMPLEMENTARY_INFORMATION" },
    
            { type: "subtitle", name: "Principales clientes", section: "COMPLEMENTARY_INFORMATION" },
            { key: "main_clients", type: "array", name: "Cliente", count: 1, section: "COMPLEMENTARY_INFORMATION" },
            { type: "subtitle", name: "Principales proveedores", section: "COMPLEMENTARY_INFORMATION" },
            { key: "main_providers", type: "array", name: "Proveedor", count: 1, section: "COMPLEMENTARY_INFORMATION" },
    
            { type: "subtitle", name: "Información de las empresas que lo conforman", section: "COMPLEMENTARY_INFORMATION" },
            { key: "is_part_of_group_company", type: "boolean", name: "¿La empresa forma parte de un grupo empresarial?", section: "COMPLEMENTARY_INFORMATION" },
            { key: ["group_company_info", "denomination"], name: "Denominación", section: "COMPLEMENTARY_INFORMATION" },
            { key: ["group_company_info", "country_desc"], name: "País de constitución", section: "COMPLEMENTARY_INFORMATION" },
            { key: ["group_company_info", "social_object"], name: "Objeto social", section: "COMPLEMENTARY_INFORMATION" },
            { key: ["group_company_info", "participation_percentage"], name: "Porcentaje de participación", section: "COMPLEMENTARY_INFORMATION" },
    
            { type: "subtitle", name: "Participación accionaria en otras empresas", section: "COMPLEMENTARY_INFORMATION" },
            { key: "has_shares_in_other_company", type: "boolean", name: "Tiene participación accionaria o vinculos patrimoniales en otras empresas, sociedades o asociaciones", section: "COMPLEMENTARY_INFORMATION" },
            { key: "other_companies", type: "array2", section: "COMPLEMENTARY_INFORMATION", obj: { name: "Nombre de empresa", commercial_business: "Giro comercial" } }
        ],
        PERSONAL_INFO: [
            { type: "subtitle", name: "Datos generales", subSection: "PERSONAL_INFO_GENERAL_INFO" },
            { type: 'name', name: "Nombre completo" },
            { key: "bcountry_desc", name: "País de nacimiento" },
            { key: "bdate", type: "date", name: "Fecha de nacimiento" },
            { key: "gender_desc", name: "Género" },
            { key: ["phone", "phone"], name: "Número telefónico" },
            { key: "email", name: "Correo electrónico" },
            { key: "retail_account_email", name: "Correo asociado a la cuenta" },
            { key: "populationid", name: "CURP" },
            { key: "account_number", name: "Número de cuenta" },
    
            { key: "identification_type", type: "catalogs", name: "Tipo de identificación" },
            { key: "identification_front", type: "link", name: "Identificación frontal" },
            { key: "identification_back", type: "link", name: "Identificación reversa" },
            { key: "all_images", type: "image", name: "Ver todas las imágenes" },
        ],
        BLACKLIST_CRUISE: [
            { key: "blacklist_external_validations", name: "Coincidencias en listas negras", type: "element", element: CreateModalBlackList, getData: true },
            { key: "blacklist_internal_validations", name: "Coincidencias en listas negras internas", type: "element", element: CreateModalBlackList, getData: true },
            { key: "status", name: "Estado del cruce", type: "text" },
            { key: "entities_scanned", name: "Entidades cruzadas", type: "text" },
            { key: "sources", name: "Fuentes consultadas", type: "text" },
            { key: "manual_check", name: "Cruce manual (manual check)", type: "text" }
        ],
        COMPANY_INFO_ACCOUNT: [
            { type: "subtitle", name: "Datos generales", subSection: "COMPANY_INFO_ACCOUNT_GENERAL_INFO" },
            { key: "comercial_name", name: "Nombre comercial" },
            { key: "economic_activity_desc", name: "Actividad económica" },
            { key: "taxid", name: "Cédula RFC" },
            { key: "taxid_file", type: "link", name: "Documento RFC" },
    
            { type: "subtitle", name: "Conocimiento del cliente" },
            { key: "source_of_account_resources", name: "Origen de los recursos de la cuenta" },
            { key: "resources_destination", name: "Uso principal de esta cuenta" },
    
            { type: "subtitle", name: "Domicilio CIF" },
            { key: ["cif_address", "country_desc"], name: "País" },
            { key: ["cif_address", "zip"], name: "Código Postal" },
            { key: ["cif_address", "state_desc"], name: "Ciudad" },
            { key: ["cif_address", "town"], name: "Alcaldía" },
            { key: ["cif_address", "locality_desc"], name: "Colonia" },
            { key: ["cif_address", "street"], name: "Calle" },
            { key: ["cif_address", "extnum"], name: "No. exterior" },
            { key: "cif_proof_of_address_file", type: "link", name: "Comprobante de domicilio" },
    
            { type: "subtitle", name: "Domicilio físico" },
            { key: ["notification_address", "country_desc"], name: "País" },
            { key: ["notification_address", "zip"], name: "Código Postal" },
            { key: ["notification_address", "state_desc"], name: "Ciudad" },
            { key: ["notification_address", "town"], name: "Alcaldía" },
            { key: ["notification_address", "locality_desc"], name: "Colonia" },
            { key: ["notification_address", "street"], name: "Calle" },
            { key: ["notification_address", "extnum"], name: "No. exterior" }
        ]
    }

    const hasAction = (action) => {
        return config?.actions?.indexOf(action) > -1;
    };

    if(hasAction("acta")){
        sections['COMPANY_INFO'].filter((i, index) => i.action === 3 ? delete sections['COMPANY_INFO'][index] : i)
    } else {
        sections['COMPANY_INFO'].map((i, index) => i.action === 1 || i.action === 2 ? delete sections['COMPANY_INFO'][index] : i)
    }

    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openSection, setOpenSection] = useState("");
    const [readySection, setReadySection] = useState([]);
    const leadService = useRef<LeadService>();

    const ensureLeadService = () => {
        if (!leadService.current) {
            leadService.current = new LeadService(changeAlert);
        }
        return leadService.current;
    };

    const getLeadSection = async (leadUuid: string, sectionName: string) => {
        setLoading(true);

        const service = ensureLeadService();
        const response = await service.getOnboardingSectionLead({
            lead_uuid: leadUuid,
            section_name: sectionName
        })
        const name = response.data?.content?.section_name
        const responseData = response.data?.content?.details || [];

        setColumns(sections[name] || []);
        setOpenSection(name);
        responseData["leadUuid"] = leadUuid
        setData(responseData);
        setLoading(false);
        return responseData;
    };

    const getSectionStatusLead = async (leadUuid: string) => {
        setLoading(true);

        const service = ensureLeadService();
        const response = await service.getSectionStatusLead({
            lead_uuid: leadUuid
        })
        const filter = response.data?.content?.sections

        setReadySection(filter || []);
        setLoading(false);
        return filter || [];
    };

    const updateSectionStatusLead = async (payload: any) => {
        setLoading(true);

        const response = await leadService.current.updateSectionStatusLead(payload)
        if(response.data.response === "OK"){
            await getSectionStatusLead(payload.lead_uuid);
        }
        setLoading(false);
    };

    const handleSectionChange = (section: OnboardingSectionLead) => {
        setColumns([]);
        setData([]);
        getLeadSection(section.lead_uuid, section.section_name)
    };

    const onSetClean = () => {
        setOpenSection("")
    }

    useEffect(() => {
        leadService.current = new LeadService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { data, loading, columns, openSection, readySection, onSetClean, handleSectionChange, getSectionStatusLead, updateSectionStatusLead }
}
